import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db, storage } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import { ClipLoader } from 'react-spinners';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { Document, Page, Text, View, StyleSheet, pdf } from "@react-pdf/renderer";
import numberToWords from "number-to-words";
import { v4 as uuidv4 } from "uuid";

function Viewdetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        console.log(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
    const [isLoading, setIsLoading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const { documentId } = useParams();
    const [services, setservices] = useState([]);

    const [bookingrooms, setbookingrooms] = useState([]);
    const [roomtypes, setroomtypes] = useState([]);
    const [rooms, setrooms] = useState([]);
    const [plans, setplans] = useState([]);
    const [itemDetails, setitemDetails] = useState([]);
    const [username, setusername] = useState("");

    const [extendRoom, setextendRoom] = useState(0)

    const [checkindetails, setcheckindetails] = useState([]);
    const [bookingData, setbookingData] = useState([]);
    const [roomservices, setroomservices] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [paymode1, setpaymode1] = useState("");
    const [entryTiming, setentryTiming] = useState(0);
    const [amount1, setamount1] = useState(0);
    const [paytime1, setpaytime1] = useState(moment().format('YYYY-MM-DD HH:mm A'));
    const [paymode2, setpaymode2] = useState("");
    const [amount2, setamount2] = useState(0);
    const [paytime2, setpaytime2] = useState("");
    const [serviceamount, setserviceamount] = useState(0);
    const [rooamount, setrooamount] = useState(0);
    const [roundoff, setroundoff] = useState(0);
    const [totalamount, settotalamount] = useState(0);
    const [advance, setadvance] = useState(0);
    const [remaining, setremaining] = useState(0)
    const [note, setnote] = useState("")

    const [serviceid, setserviceid] = useState("");
    const [roomid, setroomid] = useState("");
    const [servamount, setservamount] = useState("");
    const [quantity, setquantity] = useState(1);
    const [discountupto, setdiscountupto] = useState(10);
    const [discount, setdiscount] = useState(0);
    const [servicerate, setservicerate] = useState(0);

    const [custname, setcustname] = useState("");
    const [mobile, setmobile] = useState("");
    const [email, setemail] = useState("");
    const [address, setaddress] = useState("");
    const [city, setcity] = useState("");
    const [state, setstate] = useState("");
    const [gender, setgender] = useState("Male");
    const [visitpurpose, setvisitpurpose] = useState("Darshan");
    const [gstname, setgstname] = useState("");
    const [gstno, setgstno] = useState("");
    const [bookingsource, setbookingsource] = useState("Walking");
    const [documenttype, setdocumenttype] = useState("");
    const [idno, setidno] = useState("");
    const [adults, setadults] = useState("");
    const [childs, setchilds] = useState("");

    const [rtypeid, setrtypeid] = useState("");
    const [planid, setplanid] = useState("");
    const [amount, setamount] = useState(0);
    const [roomrate, setroomrate] = useState(0);

    const [damageamount, setdamageamount] = useState(0);
    const [damagenote, setdamagenote] = useState("");
    const [anydamage, setanydamage] = useState("No");

    const [exchangeNote, setexchangeNote] = useState("");
    const [durtyRoom, setdurtyRoom] = useState("Yes");

    const [pdfURL, setPdfURL] = useState("");


    const [roomtotal, setroomtotal] = useState(0);
    const [servicetotal, setservicetotal] = useState(0);
    const [cgst, setcgst] = useState(0);
    const [subtotal, setsubtotal] = useState(0);
    const [amountInWords, setAmountInWords] = useState("");

    const [paymodeid, setpaymodeid] = useState("");
    const [uppaymode1, setuppaymode1] = useState("");
    const [uppaymode2, setuppaymode2] = useState("");

    // ================= STATES =================

    const [serviceId, setserviceId] = useState("");
    const [serviceRoomId, setserviceRoomId] = useState("");
    const [serviceRoomName, setserviceRoomName] = useState("");

    // --- Payment History Edit States ---
    const [editingPayId, setEditingPayId] = useState("");
    const [editPaymode1, setEditPaymode1] = useState("");
    const [editAmount1, setEditAmount1] = useState(0);
    const [editPaytime1, setEditPaytime1] = useState("");
    const [editPaymode2, setEditPaymode2] = useState("");
    const [editAmount2, setEditAmount2] = useState(0);
    const [editPaytime2, setEditPaytime2] = useState("");
    const [editNote, setEditNote] = useState("");

    // --- Room Edit States ---
    const [editingRoomIndex, setEditingRoomIndex] = useState(null);
    const [editRoomAmount, setEditRoomAmount] = useState(0);
    const [editRoomDiscount, setEditRoomDiscount] = useState(0);
    const [editRoomRate, setEditRoomRate] = useState(0);


    useEffect(() => {
        fetchData1()
    }, []);

    useEffect(() => {

        const loadData = async () => {

            if (!documentId) return;

            try {
                await removeDuplicateCheckins(documentId);
                await verifyBookingData(documentId);
                await updateBookingAmounts(documentId);
                fetchData1()

            } catch (error) {
                console.log(error);
            }
        };

        loadData();

    }, [documentId]);


    const verifyBookingData = async (bookingId) => {
        try {
            console.log(bookingId);

            const bookingRef = doc(db, "bookings", bookingId);
            const bookingSnap = await getDoc(bookingRef);
            if (!bookingSnap.exists()) return;
            const booking = bookingSnap.data();
            const rooms = booking.rooms || [];
            const checkinDate = moment(booking.checkindate);
            const noofdays = parseInt(booking.noofdays);
            const validKeys = new Set();
            for (let i = 0; i < noofdays; i++) {
                const dayCheckin = checkinDate.clone().add(i, "days").format("YYYY-MM-DD");
                rooms.forEach(room => {
                    validKeys.add(room.roomid + "_" + dayCheckin);
                });

            }

            const snapshot = await getDocs(
                query(collection(db, "checkindetails"), where("bookingid", "==", bookingId))
            );

            const insertPromises = [];
            const deletePromises = [];

            snapshot.docs.forEach(docSnap => {

                const data = docSnap.data();
                const key = data.roomid + "_" + data.checkindate;

                if (!validKeys.has(key)) {

                    deletePromises.push(
                        deleteDoc(doc(db, "checkindetails", docSnap.id))
                    );

                } else {

                    validKeys.delete(key);

                }

            });

            validKeys.forEach(key => {

                const [roomid, date] = key.split("_");

                const room = rooms.find(r => r.roomid === roomid);


                const checkoutdate = moment(date).add(1, "days").format("YYYY-MM-DD");

                insertPromises.push(
                    addDoc(collection(db, "checkindetails"), {
                        bookingid: bookingId || "",
                        roomid: room.roomid || "",
                        roomname: room.roomname || "",
                        roomtypeid: room.rtypeid || "",
                        planid: room.planid || "",
                        roomtype: room.roomtypename || "",
                        planname: room.plananme || "",
                        checkindate: date || "",
                        checkoutdate: checkoutdate || "",
                        uid: userData.uid || "",
                        username: username || "",
                        status: "Booked" || "",
                        createdAt: Timestamp.now()
                    })
                );

            });

            await Promise.all([...insertPromises, ...deletePromises]);

        } catch (error) {

            console.log("Verification error:", error);

        }

    };


    const removeDuplicateCheckins = async (bookingId) => {

        try {

            const snapshot = await getDocs(
                query(collection(db, "checkindetails"), where("bookingid", "==", bookingId))
            );

            if (snapshot.empty) return;

            const seen = new Set();
            const deletePromises = [];

            snapshot.docs.forEach((docSnap) => {

                const data = docSnap.data();

                const key = `${data.bookingid}_${data.roomid}_${data.checkindate}`;

                if (seen.has(key)) {

                    deletePromises.push(
                        deleteDoc(doc(db, "checkindetails", docSnap.id))
                    );

                } else {

                    seen.add(key);

                }

            });

            if (deletePromises.length === 0) return;

            await Promise.all(deletePromises);

            console.log("Duplicate checkins removed");

        } catch (error) {

            console.log(error);

        }

    };

    const updateBookingAmounts = async (bookingId) => {

        try {

            const bookingRef = doc(db, "bookings", bookingId);
            const bookingSnap = await getDoc(bookingRef);

            if (!bookingSnap.exists()) return;

            const booking = bookingSnap.data();

            const rooms = booking.rooms || [];

            const noofdays = parseFloat(booking.noofdays || 0);
            const serviceamount = parseFloat(booking.serviceamount || 0);
            const restoamount = parseFloat(booking.restoamount || 0);
            const roundoff = parseFloat(booking.roundoff || 0);

            let roomTotal = 0;

            rooms.forEach(room => {
                roomTotal += parseFloat(room.roomrate || 0);
            });

            let allttot = (roomTotal + restoamount + roundoff) * noofdays;

            const totalAmount = serviceamount + allttot;

            const paySnap = await getDocs(
                query(collection(db, "payhistory"), where("bookingid", "==", bookingId))
            );

            let paid = 0;

            paySnap.forEach(doc => {

                const data = doc.data();

                paid +=
                    parseFloat(data.amount1 || 0) +
                    parseFloat(data.amount2 || 0);

            });

            const remaining = totalAmount - paid;

            await updateDoc(bookingRef, {
                rooamount: parseFloat(roomTotal.toFixed(2)),
                totalamount: parseFloat(totalAmount.toFixed(2)),
                advance: parseFloat(paid.toFixed(2)),
                remaining: parseFloat(remaining.toFixed(2))
            });

        } catch (error) {

            console.log("Amount calculation error:", error);

        }

    };


    const fetchData1 = async () => {
        try {
            const docRef = doc(db, "bookings", documentId);

            const [
                bookingDocSnap,
                roomServicesSnapshot,
                roomTypesSnapshot,
                paymentModesSnapshot,
                checkinDetailsSnapshot,
                payHistorySnapshot
            ] = await Promise.all([
                getDoc(docRef),
                getDocs(query(collection(db, 'roomservices'), where('status', '==', 'Active'))),
                getDocs(query(collection(db, 'roomtypes'), orderBy('createdAt', 'asc'))),
                getDocs(query(collection(db, 'paymentmodes'), orderBy('createdAt', 'asc'))),
                getDocs(query(collection(db, 'checkindetails'), where('bookingid', '==', documentId), orderBy('createdAt', 'asc'))),
                getDocs(query(collection(db, 'payhistory'), where('bookingid', '==', documentId), orderBy('createdAt', 'asc')))
            ]);

            if (!bookingDocSnap.exists()) throw new Error("Booking not found!");
            const bookingData = bookingDocSnap.data();
            setbookingData(bookingData);

            if (bookingData.createdAt) {
                const date = bookingData.createdAt.toDate();
                setentryTiming(moment(date).format('DD/MM/YYYY hh:mm:ss A'));
            }

            setroomservices(roomServicesSnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })));

            setroomtypes(roomTypesSnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })));

            const paymentModes = paymentModesSnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            }));
            setpaymodes(paymentModes);
            setpaymode1(paymentModes[0]?.id || null);
            setpaymode2(paymentModes[0]?.id || null);

            setcheckindetails(checkinDetailsSnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })));

            const paymodeIds = [];
            payHistorySnapshot.docs.forEach(doc1 => {
                const data = doc1.data();
                if (data.paymode1) paymodeIds.push(data.paymode1);
                if (data.paymode2) paymodeIds.push(data.paymode2);
            });

            const uniquePaymodeIds = [...new Set(paymodeIds)];
            const paymodeSnapshots = await Promise.all(
                uniquePaymodeIds.map(id => getDoc(doc(db, "paymentmodes", id)))
            );

            const paymodeMap = {};
            paymodeSnapshots.forEach((docSnap, index) => {
                if (docSnap.exists()) {
                    paymodeMap[uniquePaymodeIds[index]] = docSnap.data().paymode;
                }
            });

            const payHistoryData = payHistorySnapshot.docs.map(doc1 => {
                const data = doc1.data();
                const formattedDate = moment(data.createdAt.toDate()).format('DD-MM-YYYY HH:mm:ss');
                return {
                    id: doc1.id,
                    data,
                    paymode1: paymodeMap[data.paymode1] || "",
                    paymode2: paymodeMap[data.paymode2] || "",
                    createdat: formattedDate
                };
            });

            setpayhistory(payHistoryData);

            let roomTotal = parseFloat(bookingData.rooamount || 0) * parseFloat(bookingData.noofdays || 0);
            let roomTax = roomTotal * 0.5;
            setroomtotal(roomTotal.toFixed(2));

            let serviceTotal = parseFloat(bookingData.serviceamount || 0);
            setservicetotal(serviceTotal.toFixed(2));

            let totalTax = roomTax;
            let cgst = totalTax / 2;
            setcgst(cgst.toFixed(2));

            let subtotal = parseFloat(bookingData.totalamount || 0) - totalTax;
            setsubtotal(subtotal.toFixed(2));

            setAmountInWords(numberToWords.toWords(bookingData.totalamount));

        } catch (error) {
            console.error("Error fetching data:", error);
            Toast.fire({
                icon: "error",
                title: error.message || "Failed to load data!"
            });
        }
    };



    const handleamount1 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(value) + parseFloat(amount2);
        if (parseFloat(advance) > parseFloat(serviceamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + serviceamount });
            setadvance(0);
            setamount1(0)
            let rem = parseFloat(serviceamount) - parseFloat(amount2);
            setremaining(rem.toFixed(0))
            return;
        }
        setamount1(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(serviceamount) - parseFloat(advance);
        setremaining(rem.toFixed(0))

    }

    const handleamount2 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(amount1) + parseFloat(value);
        if (parseFloat(advance) > parseFloat(serviceamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + serviceamount });
            setadvance(0);
            setamount2(0)
            let rem = parseFloat(serviceamount) - parseFloat(amount1);
            setremaining(rem.toFixed(0))
            return;
        }

        setamount2(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(serviceamount) - parseFloat(advance);
        setremaining(rem.toFixed(0))
    }

    const handleamountx1 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(value) + parseFloat(amount2);

        if (!value || isNaN(remaining) || isNaN(advance)) {
            setamount1(parseFloat(totalamount) - parseFloat(amount2))
            setadvance(parseFloat(totalamount) - parseFloat(amount2));
            let rem = 0;
            setremaining(rem.toFixed(0))
        }
        else {
            setamount1(value)
            setadvance(parseFloat(amount2) + parseFloat(value));
            let rem = parseFloat(totalamount) - (parseFloat(amount2) + parseFloat(value));
            setremaining(rem.toFixed(0))
        }

    }

    const handleamountx2 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(amount1) + parseFloat(value);
        if (!value || isNaN(remaining) || isNaN(advance)) {
            setamount2(totalamount)
            setadvance(advance.toFixed(2));
            let rem = parseFloat(totalamount) - parseFloat(advance);
            setremaining(rem.toFixed(0))
        }
        if (parseFloat(remaining) < 0) {
            setamount2(parseFloat(totalamount) - parseFloat(amount1))
            setadvance(advance);
            let rem = parseFloat(totalamount) - parseFloat(advance);
            setremaining(rem.toFixed(0))
        } else {
            if (parseFloat(advance) > parseFloat(totalamount)) {
                setadvance(0);
                setremaining(totalamount)
                return;
            }
            setamount2(value)
            setadvance(advance);
            let rem = parseFloat(totalamount) - parseFloat(amount1);
            setremaining(rem.toFixed(0))
        }

    }

    const handleamount3 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(value) + parseFloat(amount2);
        if (parseFloat(advance) > parseFloat(rooamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + rooamount });
            setadvance(0);
            setamount1(0)
            let rem = parseFloat(rooamount) - parseFloat(amount2);
            setremaining(rem.toFixed(0))
            return;
        }
        setamount1(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(rooamount) - parseFloat(advance) + parseFloat(bookingData.remaining);
        setremaining(rem.toFixed(0))
    }

    const handleamount4 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(amount1) + parseFloat(value);
        if (parseFloat(advance) > parseFloat(rooamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + rooamount });
            setadvance(0);
            setamount2(0)
            let rem = parseFloat(rooamount) - parseFloat(amount1);
            setremaining(rem.toFixed(0))
            return;
        }

        setamount2(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(rooamount) - parseFloat(advance) + parseFloat(bookingData.remaining);
        setremaining(rem.toFixed(0))
    }

    const handleamount5 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(value) + parseFloat(amount2);
        if (parseFloat(advance) > parseFloat(totalamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + totalamount });
            setadvance(0);
            setamount1(0)
            let rem = parseFloat(totalamount) - parseFloat(amount2);
            setremaining(rem.toFixed(0))
            return;
        }
        setamount1(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(totalamount) - parseFloat(advance);
        setremaining(rem.toFixed(0))

    }

    const handleamount6 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(amount1) + parseFloat(value);
        if (parseFloat(advance) > parseFloat(totalamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + totalamount });
            setadvance(0);
            setamount2(0)
            let rem = parseFloat(totalamount) - parseFloat(amount1);
            setremaining(rem.toFixed(0))
            return;
        }

        setamount2(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(totalamount) - parseFloat(advance);
        setremaining(rem.toFixed(0))
    }

    const removeItem = (itemToRemove) => {
        if (window.confirm(`Are you sure you want to remove`)) {
            const updatedItems = services.filter((item) => item !== itemToRemove);
            setservices(updatedItems);

            let tamount = 0;
            for (let i = 0; i < updatedItems.length; i++) {
                tamount = parseFloat(tamount) + parseFloat(updatedItems[i].servicerate);
            }
            let rxamount = parseFloat(tamount);
            setserviceamount(rxamount.toFixed(2))
            let rem = parseFloat(rxamount) - parseFloat(advance)
            setremaining(rem.toFixed(0))
        }
    };

    const removeItem1 = (itemToRemove) => {
        if (window.confirm(`Are you sure you want to remove1`)) {
            const updatedItems = bookingrooms.filter((item) => item !== itemToRemove);
            setbookingrooms(updatedItems);

            let tamount = 0;
            for (let i = 0; i < updatedItems.length; i++) {
                tamount = parseFloat(tamount) + parseFloat(updatedItems[i].roomrate);
            }
            let rxamount = parseFloat(bookingData.noofdays) * parseFloat(tamount);
            setrooamount(rxamount.toFixed(2))
            let rem = parseFloat(rxamount) - parseFloat(advance)
            setremaining(rem.toFixed(0))
        }
    };

    const handleServiceArray = async () => {

        let num1 = quantity.toString();
        let num2 = discount.toString();

        if (!roomid || !serviceid || !servamount || !num1 || !num2 || !servicerate) {
            Toast.fire({ icon: "error", title: 'Required all fields' });
            return;
        }

        let roomname;
        let servicename;

        const docRef = doc(db, "roomdetails", roomid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            roomname = docSnap.data().roomno;
        } else {
            roomname = "";
        }

        const docRef1 = doc(db, "roomservices", serviceid);
        const docSnap1 = await getDoc(docRef1);
        if (docSnap1.exists()) {
            servicename = docSnap1.data().roomservice;
        } else {
            servicename = "";
        }

        const newItem = { roomid, serviceid, servamount, quantity, discount, servicerate, roomname, servicename, username: username, createdAt: Timestamp.now(), };
        setservices([...services, newItem]);
        setserviceid("");
        setroomid("");
        setservamount(0);
        setquantity(1);
        setdiscountupto(10);
        setdiscount(0);
        setservicerate(0);

        let tamount = 0;
        for (let i = 0; i < services.length; i++) {
            tamount = parseFloat(tamount) + parseFloat(services[i].servicerate);
        }
        let rxamount = parseFloat(tamount) + parseFloat(servicerate);
        let newamount = parseFloat(rxamount)
        setserviceamount(newamount.toFixed(2))
        let rem = parseFloat(newamount) - parseFloat(advance)
        setremaining(rem.toFixed(0))
    }


    function caltotal(qty, dis, amnt) {
        let rtot = parseFloat(qty) * parseFloat(amnt);
        let discount = parseFloat(rtot) * parseFloat(dis) / 100;
        let dirate = parseFloat(rtot) - parseFloat(discount);
        dirate = parseFloat(dirate)
        setservicerate(dirate.toFixed(2));

    }


    const handleServiceid = async (e) => {
        setserviceid(e.target.value);
        const docRef1 = doc(db, "roomservices", e.target.value);
        const docSnap1 = await getDoc(docRef1);
        if (docSnap1.exists()) {
            setservamount(docSnap1.data().amount);
            caltotal(quantity, discount, docSnap1.data().amount)
        } else {
            setservamount(0);
            caltotal(quantity, discount, 0)
        }
    }

    const handleQuantity = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (parseFloat(value) < 1 || !value) {
            caltotal(1, discount, servamount)
            setquantity(1);
        } else {
            caltotal(value, discount, servamount)
            setquantity(value)
        }
    }

    const handleDiscount = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (parseFloat(value < 0) || !value) {
            setdiscount(0)
        }
        if (parseFloat(value) > parseFloat(discountupto)) {
            Toast.fire({ icon: "error", title: 'Discount should be greater than ' + discountupto });
            setdiscount(discountupto);
            caltotal(quantity, discountupto, servamount)
            return;
        }
        else {
            setdiscount(value);
            caltotal(quantity, value, servamount)
        }
    }

    const storeService = async () => {
        setIsLoading(true)

        if (!services) {
            Toast.fire({ icon: "error", title: 'Please Select at least 1 Service' });
            return
        }

        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }
        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }


        const docRef = doc(db, "bookings", documentId);
        const docSnap = await getDoc(docRef);
        let oldservices = []
        if (docSnap.exists()) {
            let totalt = parseFloat(serviceamount) + parseFloat(docSnap.data().totalamount);
            let totals = parseFloat(serviceamount) + parseFloat(docSnap.data().serviceamount);
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(remaining) + parseFloat(docSnap.data().remaining);

            for (let i = 0; i < docSnap.data().services.length; i++) {
                oldservices.push(docSnap.data().services[i]);
            }

            for (let i = 0; i < services.length; i++) {
                oldservices.push(services[i]);
            }

            await updateDoc(doc(db, "bookings", documentId), {
                services: oldservices,
                serviceamount: parseFloat(totals),
                totalamount: parseFloat(totalt),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
            });

            await addDoc(collection(db, 'bookingservices'), {
                bookingid: documentId,
                customerId: docSnap.data().customerId,
                customers: docSnap.data().customers,
                uid: userData.uid,
                createdAt: Timestamp.now(),
                oldservices,
                type: "Booking",
            });

            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    note: note,
                    paymenttype: "B",
                    uid: userData.uid,
                    username: username,
                    type: 'Extra Service',
                    status: 'Working',
                    createdAt: Timestamp.now(),
                });
            }

            setserviceid(""); setroomid(""); setservamount(""); setquantity(1); setdiscountupto(10);
            setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2("");
            setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote("")
            Toast.fire({ icon: "success", title: 'Extra services successfully added' });
        }
        setIsLoading(false)
    }

    const getCustData = () => {
        setcustname(bookingData.customers.custname);
        setmobile(bookingData.customers.mobile);
        setemail(bookingData.customers.email);
        setaddress(bookingData.customers.address);
        setcity(bookingData.customers.city);
        setstate(bookingData.customers.state);
        setgender(bookingData.customers.gender);
        setgstname(bookingData.customers.gstname);
        setgstno(bookingData.customers.gstno);
        setdocumenttype(bookingData.customers.documenttype);
        setidno(bookingData.customers.idno);
        setvisitpurpose(bookingData.visitpurpose);
        setbookingsource(bookingData.bookingsource);
        setadults(bookingData.adults);
        setchilds(bookingData.childs);
    }

    const updateCust = async () => {
        const customerData = {
            custname: custname,
            mobile: mobile,
            email: email,
            address: address,
            city: city,
            state: state,
            gender: gender,
            gstname: gstname,
            gstno: gstno,
            documenttype: documenttype,
            idno: idno,
            uid: userData.uid,
            createdAt: Timestamp.now(),
        };

        await updateDoc(doc(db, "bookings", documentId), {
            customers: customerData,
            bookingsource: bookingsource,
            visitpurpose: visitpurpose,
            adults: adults,
            childs: childs,
        });

        await updateDoc(doc(db, "customers", bookingData.customerId), {
            customers: customerData,
            bookingsource: bookingsource,
            visitpurpose: visitpurpose,
        });
        fetchData1()
        Toast.fire({ icon: "success", title: 'Customer Details Successfully Updated' });

    }

    const handlemobile = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (value.length <= 10) {
            setmobile(value);
        }

    }


    const handleroomtypeChange = (value) => {
        setrtypeid(value);
        setamount(0);
        setroomrate(0);
        setdiscount(0);
        setdiscountupto(0);
        settotalamount(0);
        setrooamount(0)
        setadvance(0)
        setremaining(0)

        const q = query(collection(db, 'roomdetails'), where('rtypeid', '==', value), where('status', '==', 'Available'))
        onSnapshot(q, (querySnapshot) => {
            setrooms(querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })));
        });

        const q1 = query(collection(db, 'roomtarrifs'), where('rtypeid', '==', value))
        onSnapshot(q1, (querySnapshot) => {
            setplans(querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })));
        });
    }

    const handleplanChange = async (value) => {
        setplanid(value);
        try {
            const userDocRef = doc(db, 'roomtarrifs', value);
            const userDocSnap = await getDoc(userDocRef);

            if (userDocSnap.exists()) {
                let rohaamount = parseFloat(userDocSnap.data().amount);
                setamount(rohaamount.toFixed(2));
                setroomrate(rohaamount.toFixed(2));
                setdiscount(0);
                setdiscountupto(userDocSnap.data().discount);
            } else {
            }
        } catch (error) {
            console.error('Error fetching document:', error);
        }
    }

    const handleplanChange1 = async (value) => {
        setamount(0);
        setroomrate(0);
        setrooamount(0);
        setremaining(0);
        setdiscount(0);
        setdiscountupto(0);
        setplanid(value);
        try {
            const userDocRef = doc(db, 'roomtarrifs', value);
            const userDocSnap = await getDoc(userDocRef);
            if (userDocSnap.exists()) {
                let xAmount = parseFloat(userDocSnap.data().amount) - parseFloat(itemDetails.roomrate);
                let rohaxamount = parseFloat(userDocSnap.data().amount);
                setamount(rohaxamount.toFixed(2));
                setroomrate(rohaxamount.toFixed(2));
                setrooamount(xAmount.toFixed(2));
                setremaining(xAmount.toFixed(2));
                setdiscount(0);
                setdiscountupto(userDocSnap.data().discount);
            } else {
            }
        } catch (error) {
            console.error('Error fetching document:', error);
        }
    }

    const handleRoomArray = async () => {
        if (!roomid || !rtypeid || !planid || !amount || !roomrate) {
            Toast.fire({ icon: "error", title: 'Required all fields' });
            return;
        }

        let roomname;
        let roomtypename;
        let plananme;

        const docRef = doc(db, "roomdetails", roomid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            roomname = docSnap.data().roomno;
        } else {
            roomname = "";
        }

        const docRef1 = doc(db, "roomtypes", rtypeid);
        const docSnap1 = await getDoc(docRef1);
        if (docSnap1.exists()) {
            roomtypename = docSnap1.data().roomtype;
        } else {
            roomtypename = "";
        }

        const docRef2 = doc(db, "roomtarrifs", planid);
        const docSnap2 = await getDoc(docRef2);
        if (docSnap2.exists()) {
            plananme = docSnap2.data().rateplan;
        } else {
            plananme = "";
        }

        const newItem = { roomid, rtypeid, planid, amount, discount, roomrate, roomname, roomtypename, plananme, username: username };

        setbookingrooms([...bookingrooms, newItem]);
        setrtypeid("");
        setroomid("");
        setplanid("");
        setamount("");
        setdiscountupto(0);
        setdiscount("");
        setroomrate("");
        let tamount = 0;
        for (let i = 0; i < bookingrooms.length; i++) {
            tamount = parseFloat(tamount) + parseFloat(bookingrooms[i].roomrate);
        }
        let rxamount = parseFloat(tamount) + parseFloat(roomrate)
        let newamount = parseFloat(bookingData.noofdays) * parseFloat(rxamount)

        calFinalTotal(bookingData.noofdays, rxamount);
        setrooamount(newamount.toFixed(0))

        let rem = parseFloat(newamount) - parseFloat(advance)
        setremaining(rem.toFixed(0))
    }

    const calFinalTotal = (days, roomamountxx) => {
        let total = parseFloat(days) * parseFloat(roomamountxx)
        settotalamount(total.toFixed(0));
        let roundoff = total.toFixed(2) - total.toFixed(0);
        setroundoff(parseFloat(roundoff).toFixed(2));
    }

    const emptyRooms = () => {
        setamount1(0); setpaytime1(" "); setamount2(0); setpaytime2(" ");
        setserviceamount(0); setrooamount(0); setroundoff(0); settotalamount(0); setadvance(0); setremaining(0);
        setbookingrooms([]); setservices([]); setextendRoom(0)
    }
    const emptyRooms1 = () => {
        setamount1(0); setpaytime1(" "); setamount2(0); setpaytime2(" ");
        setserviceamount(0); setrooamount(0); setadvance(0); setbookingrooms([]); setservices([]); setroundoff(bookingData.roundoff);
        settotalamount(bookingData.remaining.toFixed(0)); setremaining(bookingData.remaining.toFixed(0));
    }
    const emptyRooms2 = (item) => {
        setitemDetails(item); setrtypeid(""); setroomid(""); setplanid(""); setamount(0); setdiscountupto(0); setdiscount(0); setroomrate(0); setamount1(0);
        setpaytime1(" "); setamount2(0); setpaytime2(" "); setserviceamount(0); setrooamount(0); settotalamount(0); setadvance(0); setremaining(0);
        setbookingrooms([]); setservices([]); setextendRoom(0); setroundoff(0)
    }

    const emptyRooms3 = () => {
        setamount1(0); setpaytime1(" "); setamount2(0); setpaytime2(" ");
        setserviceamount(0); setrooamount(0); setadvance(0); setbookingrooms([]); setservices([]); setroundoff(bookingData.roundoff);
        settotalamount(bookingData.restoamount.toFixed(0)); setremaining(bookingData.restoamount.toFixed(0));
    }

    function caltotal1(value) {
        setdiscount(value);
        if (value) {
            if (parseFloat(value) > parseFloat(discountupto)) {
                Toast.fire({ icon: "error", title: 'Discount should not be greater than ' + discountupto });
                setdiscount(discountupto);
                let roomr = parseFloat(amount) * parseFloat(discountupto) / 100;
                let xamount = (parseFloat(amount) - parseFloat(roomr));
                setroomrate(xamount.toFixed(2));
            } else {
                let roomr = parseFloat(amount) * parseFloat(value) / 100;
                let xamount = (parseFloat(amount) - parseFloat(roomr));
                setroomrate(xamount.toFixed(2));
            }
        }
        else {
            setdiscount(0)
        }
    }


    function caltotal2(value) {
        setdiscount(value);
        if (value) {
            if (parseFloat(value) > parseFloat(discountupto)) {
                Toast.fire({ icon: "error", title: 'Discount should not be greater than ' + discountupto });
                setdiscount(discountupto);
                let roomr = parseFloat(amount) * parseFloat(discountupto) / 100;
                let xamount = (parseFloat(amount) - parseFloat(roomr));
                setroomrate(xamount.toFixed(2));
                let rem = parseFloat(xamount) - parseFloat(itemDetails.roomrate);
                setrooamount(rem.toFixed(2));
            } else {
                let roomr = parseFloat(amount) * parseFloat(value) / 100;
                let xamount = (parseFloat(amount) - parseFloat(roomr));
                setroomrate(xamount.toFixed(2));
                let rem = parseFloat(xamount) - parseFloat(itemDetails.roomrate);
                setrooamount(rem.toFixed(2));
            }
        }
        else {
            setdiscount(0)
        }
    }


    const storeRoom = async () => {
        if (!rooms) {
            Toast.fire({ icon: "error", title: 'Please Select at least 1 Service' });
            return
        }

        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }

        setIsLoading(true)

        const docRef = doc(db, "bookings", documentId);
        const docSnap = await getDoc(docRef);
        let oldrooms = []
        if (docSnap.exists()) {
            let totals = (parseFloat(rooamount) / parseFloat(bookingData.noofdays)) + parseFloat(docSnap.data().rooamount);
            let totalt = parseFloat(rooamount) + parseFloat(docSnap.data().totalamount);
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(remaining) + parseFloat(docSnap.data().remaining);


            for (let i = 0; i < docSnap.data().noofdays; i++) {
                for (let j = 0; j < bookingrooms.length; j++) {
                    await addDoc(collection(db, 'checkindetails'), {
                        bookingid: documentId,
                        customerId: docSnap.data().customerId,
                        checkindate: moment(docSnap.data().checkindate).add(i, 'days').format('YYYY-MM-DD'),
                        checkoutdate: moment(docSnap.data().checkindate).add(i + 1, 'days').format('YYYY-MM-DD'),
                        roomid: bookingrooms[j].roomid,
                        roomtypeid: bookingrooms[j].rtypeid,
                        planid: bookingrooms[j].planid,
                        roomname: bookingrooms[j].roomname,
                        planname: bookingrooms[j].plananme,
                        roomtype: bookingrooms[j].roomtypename,
                        uid: userData.uid,
                        username: username,
                        status: 'Booked',
                        createdAt: Timestamp.now(),
                    });
                }
            }

            for (let i = 0; i < docSnap.data().rooms.length; i++) {
                oldrooms.push(docSnap.data().rooms[i]);
            }
            for (let i = 0; i < bookingrooms.length; i++) {
                oldrooms.push(bookingrooms[i]);
            }


            await updateDoc(doc(db, "bookings", documentId), {
                rooms: oldrooms,
                rooamount: parseFloat(totals),
                totalamount: parseFloat(totalt),
                roundoff: parseFloat(roundoff),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
                noofrooms: oldrooms.length
            });

            await addDoc(collection(db, 'bookingrooms'), {
                bookingid: documentId,
                customerId: docSnap.data().customerId,
                customers: docSnap.data().customers,
                uid: userData.uid,
                createdAt: Timestamp.now(),
                bookingrooms,
            });

            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    note: note,
                    paymenttype: "B",
                    uid: userData.uid,
                    username: username,
                    type: 'New Room Payments',
                    status: 'Working',
                    createdAt: Timestamp.now(),
                });
            }

            for (let i = 0; i < oldrooms.length; i++) {
                await updateDoc(doc(db, "roomdetails", oldrooms[i].roomid), {
                    status: "Booked",
                });
            }


            setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
            setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
            setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
            setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
            Toast.fire({ icon: "success", title: 'New Rooms successfully added' });
        }

        setIsLoading(false)
    }

    const storePayment = async () => {
        setIsLoading(true)
        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }
        const docRef = doc(db, "bookings", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(docSnap.data().totalamount) - parseFloat(totalp);

            await updateDoc(doc(db, "bookings", documentId), {
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
            });
            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    paymenttype: "B",
                    note: note,
                    uid: userData.uid,
                    username: username,
                    status: 'Working',
                    type: 'Payments Taken from Customers',
                    createdAt: Timestamp.now(),
                });
            }
        }

        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Payment successfully added' });
        setIsLoading(false)
    }

    const storePayment1 = async () => {
        setIsLoading(true)
        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }
        const docRef = doc(db, "bookings", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let totalp = parseFloat(docSnap.data().advance) + parseFloat(advance);
            let totalr = parseFloat(docSnap.data().totalamount.toFixed(2)) - parseFloat(totalp.toFixed(2));


            await updateDoc(doc(db, "bookings", documentId), {
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
            });
            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    note: note,
                    uid: userData.uid,
                    username: username,
                    status: 'Working',
                    paymenttype: "B",
                    type: 'Payments given to Customers',
                    createdAt: Timestamp.now(),
                });
            }
        }

        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Payment successfully added' });
        setIsLoading(false)
    }

    const storeRestoPayment = async () => {
        setIsLoading(true)
        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }
        const docRef = doc(db, "bookings", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(docSnap.data().totalamount) - parseFloat(totalp);

            await updateDoc(doc(db, "bookings", documentId), {
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
            });

            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    paymenttype: "B",
                    note: note,
                    uid: userData.uid,
                    username: username,
                    status: 'Working',
                    type: 'Payments Taken from Customers',
                    createdAt: Timestamp.now(),
                });
            }
        }

        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Food Amount Successfully Paid' });
        setIsLoading(false)
    }

    const handleExtendRoom = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (value.length <= 2 || value) {
            setextendRoom(value);
            let tot = parseFloat(value) * (parseFloat(bookingData.rooamount));
            settotalamount(tot.toFixed(0));
            setremaining(tot.toFixed(0));
            let roundoff = tot.toFixed(2) - tot.toFixed(0);
            setroundoff(parseFloat(roundoff).toFixed(2));
        }
    }

    const handleReduceRoom = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (value.length <= 2 || value) {
            if (parseFloat(value) >= bookingData.noofdays) {
                Toast.fire({ icon: "error", title: 'No of days should not be less than or equal to ' + bookingData.noofdays });
                let ramm = bookingData.noofdays - 1;
                setextendRoom(ramm);
                let tot = parseFloat(ramm) * (parseFloat(bookingData.rooamount) + parseFloat(bookingData.serviceamount));
                settotalamount(tot.toFixed(0));
                return
            }
            setextendRoom(value);
            let tot = parseFloat(value) * (parseFloat(bookingData.rooamount) + parseFloat(bookingData.serviceamount));
            settotalamount(tot.toFixed(0));
        }
    }

    const extendRoomStore = async () => {
        setIsLoading(true)
        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }
        if (extendRoom < 1 || !extendRoom) {
            Toast.fire({ icon: "error", title: 'Please Enter No of day ' });
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }
        const docRef = doc(db, "bookings", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let totala = parseFloat(totalamount) + parseFloat(docSnap.data().totalamount);
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(totala) - parseFloat(totalp)
            let roundofff = parseFloat(totala).toFixed(2) - parseFloat(totala).toFixed(0);

            let checkout = moment(bookingData.checkoutdate).add(extendRoom, 'days').format('YYYY-MM-DD')
            await updateDoc(doc(db, "bookings", documentId), {
                totalamount: parseFloat(totala),
                roundoff: parseFloat(roundofff),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
                checkoutdate: checkout,
                noofdays: parseFloat(bookingData.noofdays) + parseFloat(extendRoom),
            });
            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    paymenttype: "B",
                    note: note,
                    uid: userData.uid,
                    status: 'Working',
                    type: 'Room Extension Payment',
                    username: username,
                    createdAt: Timestamp.now(),
                });
            }

            for (let i = 0; i < extendRoom; i++) {
                for (let j = 0; j < bookingData.rooms.length; j++) {
                    await addDoc(collection(db, 'checkindetails'), {
                        bookingid: documentId,
                        customerId: bookingData.customerId,
                        checkindate: moment(bookingData.checkoutdate).add(i, 'days').format('YYYY-MM-DD'),
                        checkoutdate: moment(bookingData.checkoutdate).add(i + 1, 'days').format('YYYY-MM-DD'),
                        roomid: bookingData.rooms[j].roomid,
                        roomtypeid: bookingData.rooms[j].rtypeid,
                        planid: bookingData.rooms[j].planid,
                        roomname: bookingData.rooms[j].roomname,
                        planname: bookingData.rooms[j].plananme,
                        roomtype: bookingData.rooms[j].roomtypename,
                        uid: userData.uid,
                        username: username,
                        status: 'Booked',
                        createdAt: Timestamp.now(),
                    });
                }
            }
        }

        await addDoc(collection(db, 'logs'), {
            bookingid: documentId,
            customerId: bookingData.customerId,
            customers: bookingData.customers,
            rooms: bookingData.rooms,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Room Extended ',
        });

        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Room Successfully Extended  ' });
        setIsLoading(false)
        await removeDuplicateCheckins(documentId);

        await verifyBookingData(documentId);

        await updateBookingAmounts(documentId);
    }


    const reduceRoomStore = async () => {


        const docRef = doc(db, "bookings", documentId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            let totala = parseFloat(docSnap.data().totalamount) - parseFloat(totalamount);
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(totala) - parseFloat(totalp)
            let roundofff = parseFloat(totala).toFixed(2) - parseFloat(totala).toFixed(0);

            let checkout = moment(bookingData.checkoutdate).subtract(extendRoom, 'days').format('YYYY-MM-DD')
            await updateDoc(doc(db, "bookings", documentId), {
                totalamount: parseFloat(totala),
                roundoff: parseFloat(roundofff),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
                checkoutdate: checkout,
                noofdays: parseFloat(bookingData.noofdays) - parseFloat(extendRoom),
            });

            await addDoc(collection(db, 'logs'), {
                bookingid: documentId,
                customerId: bookingData.customerId,
                customers: bookingData.customers,
                rooms: bookingData.rooms,
                uid: userData.uid,
                username: username,
                createdAt: Timestamp.now(),
                type: 'Room Reduced ',
            });

        }

        await removeDuplicateCheckins(documentId);

        await verifyBookingData(documentId);

        await updateBookingAmounts(documentId);

        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Room Successfully Reduced  ' });
    }

    const handleOpenPayHistoryEdit = (item) => {
        setEditingPayId(item.id);
        setEditPaymode1(item.data.paymode1 || "");
        setEditAmount1(item.data.amount1 || 0);
        setEditPaytime1(item.data.paytime1 || "");
        setEditPaymode2(item.data.paymode2 || "");
        setEditAmount2(item.data.amount2 || 0);
        setEditPaytime2(item.data.paytime2 || "");
        setEditNote(item.data.note || "");
    };

    const updatePaymentHistory = async () => {
        if (!editingPayId) return;

        const amt1 = parseFloat(editAmount1) || 0;
        const amt2 = parseFloat(editAmount2) || 0;

        if (amt1 < 0 || amt2 < 0) {
            Toast.fire({ icon: "error", title: "Amount cannot be negative" });
            return;
        }

        try {
            setIsLoading(true);
            await updateDoc(doc(db, "payhistory", editingPayId), {
                paymode1: editPaymode1,
                amount1: amt1,
                paytime1: editPaytime1,
                paymode2: editPaymode2,
                amount2: amt2,
                paytime2: editPaytime2,
                note: editNote,
            });

            await addDoc(collection(db, "logs"), {
                bookingid: documentId,
                customerId: bookingData.customerId,
                customers: bookingData.customers,
                uid: userData.uid,
                username: username,
                createdAt: Timestamp.now(),
                type: "Payment History Updated",
            });

            await updateBookingAmounts(documentId);
            await fetchData1();

            Toast.fire({ icon: "success", title: "Payment record updated successfully" });
        } catch (error) {
            console.error("Error updating payment:", error);
            Toast.fire({ icon: "error", title: "Failed to update payment record" });
        } finally {
            setIsLoading(false);
        }
    };

    // --- Room Edit Handlers ---
    const handleOpenRoomEdit = (index, room) => {
        setEditingRoomIndex(index);
        setEditRoomAmount(room.amount || 0);
        setEditRoomDiscount(room.discount || 0);
        setEditRoomRate(room.roomrate || 0);
    };

    const handleEditRoomAmountChange = (val) => {
        const amt = parseFloat(val) || 0;
        setEditRoomAmount(amt);
        const disc = parseFloat(editRoomDiscount) || 0;
        const discountedRate = amt - (amt * disc) / 100;
        setEditRoomRate(discountedRate.toFixed(2));
    };

    const handleEditRoomDiscountChange = (val) => {
        const disc = parseFloat(val) || 0;
        setEditRoomDiscount(disc);
        const amt = parseFloat(editRoomAmount) || 0;
        const discountedRate = amt - (amt * disc) / 100;
        setEditRoomRate(discountedRate.toFixed(2));
    };

    const updateRoomDetails = async () => {
        if (editingRoomIndex === null) return;

        try {
            setIsLoading(true);
            const updatedRooms = [...bookingData.rooms];
            updatedRooms[editingRoomIndex] = {
                ...updatedRooms[editingRoomIndex],
                amount: parseFloat(editRoomAmount) || 0,
                discount: parseFloat(editRoomDiscount) || 0,
                roomrate: parseFloat(editRoomRate) || 0,
            };

            const bookingRef = doc(db, "bookings", documentId);
            await updateDoc(bookingRef, {
                rooms: updatedRooms
            });

            await addDoc(collection(db, "logs"), {
                bookingid: documentId,
                customerId: bookingData.customerId,
                customers: bookingData.customers,
                uid: userData.uid,
                username: username,
                createdAt: Timestamp.now(),
                type: "Room Details Updated",
            });

            await updateBookingAmounts(documentId);
            await fetchData1();

            Toast.fire({ icon: "success", title: "Room details updated successfully" });
        } catch (error) {
            console.error("Error updating room:", error);
            Toast.fire({ icon: "error", title: "Failed to update room details" });
        } finally {
            setIsLoading(false);
        }
    };


    const storeRoomExchange = async () => {
        setIsLoading(true)
        if (!roomid || !rtypeid || !planid || !amount || !roomrate) {
            Toast.fire({ icon: "error", title: 'Please select another room with amount' });
            return;
        }

        let roomname;
        let roomtypename;
        let plananme;

        const docRef = doc(db, "roomdetails", roomid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            roomname = docSnap.data().roomno;
        } else {
            roomname = "";
        }

        const docRef1 = doc(db, "roomtypes", rtypeid);
        const docSnap1 = await getDoc(docRef1);
        if (docSnap1.exists()) {
            roomtypename = docSnap1.data().roomtype;
        } else {
            roomtypename = "";
        }

        plananme = planid;

        let newArray = [];
        const newItem1X = { roomid, rtypeid, planid, amount, discount, roomrate, roomname, roomtypename, plananme, username: username, status: "Exchanged", exchangeNote: exchangeNote };
        for (let i = 0; i < bookingData.rooms.length; i++) {
            if (bookingData.rooms[i].roomid !== itemDetails.roomid) {
                newArray.push(bookingData.rooms[i])
            }
        }
        newArray.push(newItem1X);

        let newroomamount = parseFloat(bookingData.rooamount) - parseFloat(itemDetails.roomrate)

        let tttttttttttt = (parseFloat(newroomamount) + parseFloat(bookingData.serviceamount) + parseFloat(roomrate)) * parseFloat(bookingData.noofdays);
        let rem = parseFloat(tttttttttttt) - parseFloat(bookingData.advance)
        let roundofff = parseFloat(tttttttttttt).toFixed(2) - parseFloat(tttttttttttt).toFixed(0);

        await updateDoc(doc(db, "bookings", documentId), {
            totalamount: parseFloat(tttttttttttt),
            roundoff: parseFloat(roundofff).toFixed(2),
            rooamount: parseFloat(newroomamount) + parseFloat(roomrate),
            remaining: parseFloat(rem),
            rooms: newArray,
        });

        let bookingrooms = newArray;

        await addDoc(collection(db, 'bookingrooms'), {
            bookingid: documentId,
            customerId: bookingData.customerId,
            customers: bookingData.customers,
            uid: userData.uid,
            createdAt: Timestamp.now(),
            bookingrooms,
        });

        await updateDoc(doc(db, "roomdetails", roomid), {
            status: "Booked",
        });

        await updateDoc(doc(db, "bookings", documentId), {
            approval1: "No",
        });

        if (durtyRoom === 'Yes') {
            await updateDoc(doc(db, "roomdetails", itemDetails.roomid), {
                status: "Cleaning",
            });

            await addDoc(collection(db, 'cleaningrooms'), {
                bookingid: documentId,
                roomid: itemDetails.roomid,
                roomname: itemDetails.roomname,
                uid: userData.uid,
                username: username,
                status: 'Cleaning',
                cleanedby: "",
                cleanedtime: "",
                createdAt: Timestamp.now(),
            });

        } else {
            await updateDoc(doc(db, "roomdetails", itemDetails.roomid), {
                status: "Available",
            });
        }

        await addDoc(collection(db, 'logs'), {
            bookingid: documentId,
            customerId: bookingData.customerId,
            customers: bookingData.customers,
            rooms: bookingData.rooms,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Room Exchanged',
        });


        const q1 = query(collection(db, 'checkindetails'), where('bookingid', '==', documentId), where('roomid', '==', itemDetails.roomid), where('checkindate', '>=', moment().format('YYYY-MM-DD')))
        onSnapshot(q1, async (querySnapshot1) => {
            for (const doc1 of querySnapshot1.docs) {
                await updateDoc(doc(db, "checkindetails", doc1.id), {
                    roomid: newItem1X.roomid,
                    roomtypeid: newItem1X.rtypeid,
                    planid: newItem1X.planid,
                    roomname: newItem1X.roomname,
                    planname: newItem1X.plananme,
                    roomtype: newItem1X.roomtypename,
                    uid: userData.uid,
                    username: username,
                });
            }
        });

        await removeDuplicateCheckins(documentId);

        await verifyBookingData(documentId);

        await updateBookingAmounts(documentId);
        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([]);
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Room Successfully Exchanged  ' })
        setIsLoading(false)

    }

    const cancleExtraService = async (item) => {

        if (window.confirm(`Are you sure you want to Cancle Extra Service`)) {
            let newArray = [];
            for (let i = 0; i < bookingData.services.length; i++) {
                if (bookingData.services[i].serviceid !== item.serviceid) {
                    newArray.push(bookingData.services[i])
                }
            }

            let newservicerate = parseFloat(item.servicerate) * parseFloat(bookingData.noofdays)
            let newrserviceamount = parseFloat(bookingData.serviceamount) - parseFloat(newservicerate)
            let newrtotamount = parseFloat(bookingData.totalamount) - parseFloat(newservicerate)
            let newRemaining = parseFloat(newrtotamount) - parseFloat(bookingData.advance)
            let roundofff = parseFloat(newrtotamount).toFixed(2) - parseFloat(newrtotamount).toFixed(0);

            await updateDoc(doc(db, "bookings", documentId), {
                totalamount: parseFloat(newrtotamount),
                roundofff: parseFloat(roundofff).toFixed(2),
                serviceamount: parseFloat(newrserviceamount),
                remaining: parseFloat(newRemaining),
                services: newArray,
            });

            let oldservices = newArray;
            await addDoc(collection(db, 'bookingservices'), {
                bookingid: documentId,
                customerId: bookingData.customerId,
                customers: bookingData.customers,
                uid: userData.uid,
                createdAt: Timestamp.now(),
                oldservices
            });

            await addDoc(collection(db, 'logs'), {
                bookingid: documentId,
                customerId: bookingData.customerId,
                customers: bookingData.customers,
                services: item,
                uid: userData.uid,
                username: username,
                createdAt: Timestamp.now(),
                type: 'Extra Service Cancled',
            });

            await updateDoc(doc(db, "bookings", documentId), {
                approval3: "No",
            });


            setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
            setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
            setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([]);
            setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
            Toast.fire({ icon: "success", title: 'Extra Service Successfully Cancled ' })
        }

        await removeDuplicateCheckins(documentId);

        await verifyBookingData(documentId);

        await updateBookingAmounts(documentId);

    }

    const handleDamageAmount = (e) => {
        if (e.target.value) {
            setdamageamount(parseFloat(e.target.value, 10));
            let tot = parseFloat(bookingData.remaining) + parseFloat(e.target.value);
            setremaining(parseFloat(tot).toFixed(0));
            settotalamount(parseFloat(tot).toFixed(0))
            let roundoff = tot.toFixed(2) - tot.toFixed(0);
            setroundoff(parseFloat(roundoff).toFixed(2));
        }
        else {
            setdamageamount(0);
            setremaining(parseFloat(bookingData.remaining));
            settotalamount(parseFloat(bookingData.remaining))
        }

    }

    const handleCheckout = async () => {

        setIsLoading(true)

        if (anydamage === 'Yes') {
            await addDoc(collection(db, 'damages'), {
                bookingid: documentId,
                customerId: bookingData.customerId,
                customers: bookingData.customers,
                rooms: bookingData.rooms,
                damageamount: damageamount,
                damagenote: damagenote,
                uid: userData.uid,
                username: username,
                createdAt: Timestamp.now(),
            });
        }

        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            setIsLoading(false)
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    setIsLoading(false)
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                setIsLoading(false)
                return
            }
        }
        const docRef = doc(db, "bookings", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let totalt = parseFloat(bookingData.totalamount) + parseFloat(damageamount);
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(totalt) - parseFloat(totalp);
            let roundofff = parseFloat(totalt).toFixed(2) - parseFloat(totalt).toFixed(0);

            await updateDoc(doc(db, "bookings", documentId), {
                totalamount: parseFloat(totalt),
                roundofff: parseFloat(roundofff).toFixed(2),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
                damageamount: parseFloat(damageamount),
                status: 'Checkout',
                checkouttime: moment().format("HH:mm A"),
                extra4: moment().format("DD-MM-YYYY HH:mm A")
            });

            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    note: note,
                    paymenttype: "B",
                    uid: userData.uid,
                    username: username,
                    status: 'Working',
                    type: 'Payments Taken from Customers',
                    createdAt: Timestamp.now(),
                });
            }

            const q = query(collection(db, "checkindetails"), where("bookingid", "==", documentId));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach(async (document) => {
                await updateDoc(doc(db, "checkindetails", document.id), {
                    status: "Checkout",
                });
            });

            for (let i = 0; i < bookingData.rooms.length; i++) {
                await updateDoc(doc(db, "roomdetails", bookingData.rooms[i].roomid), {
                    status: "Cleaning",
                });

                await addDoc(collection(db, 'cleaningrooms'), {
                    bookingid: documentId,
                    roomid: bookingData.rooms[i].roomid,
                    roomname: bookingData.rooms[i].roomname,
                    uid: userData.uid,
                    username: username,
                    status: 'Cleaning',
                    cleanedby: "",
                    cleanedtime: "",
                    createdAt: Timestamp.now(),
                });
            }

            await addDoc(collection(db, 'checkouthistory'), {
                bookingid: documentId,
                invoiceno: docSnap.data().invoiceno,
                customerId: docSnap.data().customerId,
                customers: docSnap.data().customers,
                checkindate: bookingData.checkindate,
                checkoutdate: bookingData.checkoutdate,
                rooms: docSnap.data().rooms,
                uid: userData.uid,
                username: username,
                totalamount: parseFloat(totalt),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
                checkoutime: moment().format('DD/MM/YYYY HH:mm:ss A'),
                createdAt: Timestamp.now(),
            });
        }


        await addDoc(collection(db, 'logs'), {
            bookingid: documentId,
            customerId: bookingData.customerId,
            customers: bookingData.customers,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Room Checkouts',
        });


        if (parseFloat(bookingData.restoamount) > 0) {

            const q = query(collection(db, 'orders'), where('bookingId', '==', documentId));
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
                querySnapshot.forEach(async (docSnapshot) => {
                    const orderRef = doc(db, 'orders', docSnapshot.id);
                    await updateDoc(orderRef, {
                        status: 'Active',
                        paytype: paymode2
                    });
                });
            } else {
                console.log('No orders found for the given bookingid.');
            }
        }

        await removeDuplicateCheckins(documentId);

        await verifyBookingData(documentId);

        await updateBookingAmounts(documentId);

        setIsLoading(false)

        Toast.fire({ icon: "success", title: 'Room Successfully Checkout' });
        uploadInvoiceToFirebase()
    }


    const deletCheckin = async (docid) => {
        console.log(docid);

        const taskDocRef = doc(db, 'checkindetails', docid)
        await deleteDoc(taskDocRef)
        Toast.fire({
            icon: "success",
            title: ' Deleted Successfully!!'
        });
        fetchData1();


        await addDoc(collection(db, 'logs'), {
            bookingid: documentId,
            customerId: bookingData.customerId,
            customers: bookingData.customers,
            rooms: bookingData.rooms,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Checkin Delete',
        });

        await removeDuplicateCheckins(documentId);

        await verifyBookingData(documentId);

        await updateBookingAmounts(documentId);
    }

    const deletPyament = async (docid) => {
        if (!window.confirm("Are you sure you want to delete this payment record?")) return;

        try {
            setIsLoading(true);
            await deleteDoc(doc(db, "payhistory", docid));

            await addDoc(collection(db, "logs"), {
                bookingid: documentId,
                customerId: bookingData.customerId,
                customers: bookingData.customers,
                rooms: bookingData.rooms,
                uid: userData?.uid || "",
                username: username,
                createdAt: Timestamp.now(),
                type: "Payment History Deleted",
            });

            await updateBookingAmounts(documentId);
            await fetchData1();

            Toast.fire({
                icon: "success",
                title: "Deleted Successfully!!",
            });
        } catch (error) {
            console.error("Error deleting payment:", error);
            Toast.fire({ icon: "error", title: "Failed to delete payment" });
        } finally {
            setIsLoading(false);
        }
    };

    const hanldeServeAmount = (e) => {
        setservamount(e.target.value);
        setservamount(e.target.value);
        caltotal(quantity, discount, e.target.value)
    }


    const uploadInvoiceToFirebase = async () => {
        try {
            const pdfBlob = await pdf(<InvoicePDF invoiceData={documentId} />).toBlob();

            const storageRef = ref(storage, `invoices/invoice_${Date.now()}.pdf`);
            const uploadTask = uploadBytesResumable(storageRef, pdfBlob);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    console.log(`Progress: ${(snapshot.bytesTransferred / snapshot.totalBytes) * 100}%`);
                },
                (error) => {
                    console.error("Upload failed:", error);
                },
                async () => {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    setPdfURL(downloadURL);

                    const querySnapshot = await getDocs(collection(db, "whatsapp"));

                    if (!querySnapshot.empty) {
                        const firstDoc = querySnapshot.docs[0].data();
                        if (firstDoc.status === 'ON') {
                            if (firstDoc.mobile === 'ROHAN') {
                            }
                            else {
                                sendWhatsAppMessage(bookingData.customers.mobile, downloadURL)
                            }
                        }
                    }
                    console.log("Invoice uploaded:", downloadURL);
                }
            );
        } catch (error) {
            console.error("Error generating/uploading PDF:", error);
        }
    }


    const sendWhatsAppMessage = async (mobileno, downloadURL) => {
        const wabaid = "591801274016500";
        const accesstoken = "EAAIYwoDRSHsBO6o4NeCQr0f1v9PrWvvI31boSykl9sGxFX4xZBzznLazzVm9LbaqNrBYSZAjccUUwjBohCovlp5l5RwESrnk3fkZCzLjNRVAbptz591adwdjQyZBx3FcMnIfAzz1oZBO1QxldkLzgOrR77KuDxfSz3vCFSZAy2Tz0s5RFmkUN5DbljSdn7N5qI6AZDZD";

        const payload = {
            messaging_product: 'whatsapp',
            recipient_type: 'individual',
            to: '91' + mobileno,
            type: 'template',
            template: {
                name: 'invoice_tamplate',
                language: {
                    code: 'en_US',
                },

                components: [
                    {
                        type: 'header',
                        parameters: [
                            {
                                type: "document",
                                document: {
                                    link: downloadURL,
                                    filename: 'Invoice.pdf'
                                }
                            }
                        ]
                    }
                ],
            },
        };

        try {
            const response = await fetch(`https://graph.facebook.com/v20.0/${wabaid}/messages`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accesstoken}`,
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.ok) {
                console.log('Response:', data);
                await addDoc(collection(db, 'whatsapphistory'), {
                    type: 'Checkout',
                    custname: custname,
                    mobile: mobile,
                    createdAt: Timestamp.now(),
                });
                window.location.href = "/checkout-history"

            } else {
                alert(`❌ Error: ${data.error.message}`);
                console.error('API Error:', data);
                window.location.href = "/checkout-history"

            }
        } catch (error) {
            console.error('Fetch Error:', error);
            alert('❌ Failed to send the message.');
            window.location.href = "/checkout-history"
        }
    };


    const handlePaymodeEdit = (id, paymode1, paymode2) => {
        setpaymodeid(id);
        setuppaymode1(paymode1);
        setuppaymode2(paymode2);
    }

    const updatePaymode = async () => {
        await updateDoc(doc(db, "payhistory", paymodeid), {
            paymode1: uppaymode1,
            paymode2: uppaymode2,
        });

        fetchData1()
        Toast.fire({ icon: "success", title: 'Payment Mode successfully updated' });
    }


    const handleamount = (e) => {
        setamount(e.target.value);
        setdiscount(0);
        setroomrate(e.target.value);
    }


    const deleteRoom = async (index) => {

        try {

            if (!window.confirm("Are you sure you want to delete this room?")) return;

            const bookingRef = doc(db, "bookings", documentId);

            const updatedRooms = [...bookingData.rooms];

            updatedRooms.splice(index, 1);

            await updateDoc(bookingRef, {
                rooms: updatedRooms
            });

            Toast.fire({
                icon: "success",
                title: "Room Deleted Successfully"
            });

        } catch (error) {
            console.log(error);
        }

    };

    const updateServiceRoom = async () => {

        try {

            if (!serviceId || !serviceRoomId) {

                Toast.fire({
                    icon: "error",
                    title: "Please select room"
                });

                return;
            }

            const updatedServices = bookingData.services.map((item) => {

                if (item.serviceid === serviceId) {

                    return {
                        ...item,
                        roomid: serviceRoomId,
                        roomname: serviceRoomName
                    }

                }

                return item;

            });

            const bookingRef = doc(db, "bookings", documentId);

            await updateDoc(bookingRef, {
                services: updatedServices
            });

            Toast.fire({
                icon: "success",
                title: "Service Room Updated Successfully"
            });

        } catch (error) {

            console.log(error);

            Toast.fire({
                icon: "error",
                title: error.message
            });

        }

    }

    const InvoicePDF = () => (
        <Document>
            <Page size="A4" style={styles.page}>


                <View style={styles.columnContainer1}>
                    <View style={styles.column1}>
                        <View style={styles.section1}>
                            <Text style={styles.header}>Dasara Executive</Text>
                            <Text style={styles.subHeader}>GSTIN No - 27AAGCD7108K1ZH</Text>
                            <Text style={styles.subHeader}>Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601</Text>
                            <Text style={styles.subHeader}>Phone: +91 9975294940 | Email: dasaraexecutive@gmail.com</Text>
                            <Text style={styles.subHeader}>Website: www.dasaraexecutive.com</Text>
                        </View>
                    </View>
                    <View >
                        <View style={styles.section1}>
                            <Text style={styles.header}>TAX INVOICE</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.columnContainer1}>
                    <View style={styles.column}>
                        <View style={styles.section1}>
                            <View style={styles.row}>
                                <Text style={styles.label}>Name:</Text>
                                <Text style={styles.value}>{bookingData.customers.custname}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Address:</Text>
                                <Text style={styles.value}>{bookingData.customers.address} , {bookingData.customers.city},   {bookingData.customers.state} </Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Phone:</Text>
                                <Text style={styles.value}>{bookingData.customers.mobile}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Email:</Text>
                                <Text style={styles.value1}>{bookingData.customers.email}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>GST Name:</Text>
                                <Text style={styles.value}>{bookingData.customers.gstname}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>GST No:</Text>
                                <Text style={styles.value}>{bookingData.customers.gstno}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.column}>
                        <View style={styles.section1}>
                            <View style={styles.row}>
                                <Text style={styles.label}>Invoice No:</Text>
                                <Text style={styles.value}>{bookingData.invoiceno}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Invoice Date:</Text>
                                <Text style={styles.value}>{moment().format('DD/MM/YYYY HH:mm A')}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>No Of Rooms:</Text>
                                <Text style={styles.value}> {bookingData.noofrooms} Rooms</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>No of Days:</Text>
                                <Text style={styles.value}>{bookingData.noofdays} Days</Text>
                            </View>

                            <View style={styles.row}>
                                <Text style={styles.label}>Check-In Date:</Text>
                                <Text style={styles.value}>{moment(bookingData.checkindate).format('DD/MM/YYYY')}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Check-Out Date:</Text>
                                <Text style={styles.value}>{moment(bookingData.checkoutdate).format('DD/MM/YYYY')}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>No Of Persons:</Text>
                                <Text style={styles.value}> {bookingData.adults} (A) / {bookingData.childs} (C)</Text>
                            </View>
                        </View>
                    </View>

                </View>

                <View style={styles.section2}>
                    <View style={styles.tableHeader}>
                        <Text style={{ width: '15%' }}>Room Type</Text>
                        <Text style={{ width: '10%' }}>Room No</Text>
                        <Text style={{ width: '15%' }}>Plan Name</Text>
                        <Text style={{ width: '10%', textAlign: 'right' }}>Rate</Text>
                        <Text style={{ width: '10%', textAlign: 'right' }}>No Of Day</Text>
                        <Text style={{ width: '15%', textAlign: 'right' }}>Room Amount</Text>
                        <Text style={{ width: '10%', textAlign: 'right' }}>Discount</Text>
                        <Text style={{ width: '15%', textAlign: 'right' }}>Total (Inc Tax)</Text>
                    </View>
                    {bookingData.rooms.map((item, index) => {
                        let diaamount = (parseFloat(item.amount) - parseFloat(item.roomrate)) * parseFloat(bookingData.noofdays);
                        let amount = parseFloat(item.amount);
                        let roomrate = parseFloat(item.roomrate) * parseFloat(bookingData.noofdays);
                        let totall = parseFloat(item.amount) * parseFloat(bookingData.noofdays);
                        return (
                            <View style={styles.tableRow} key={index}>
                                <Text style={{ width: '15%' }}>{item.roomtypename}</Text>
                                <Text style={{ width: '10%' }}>{item.roomname} {item.status === 'Exchanged' && " (Exchanged)"}</Text>
                                <Text style={{ width: '15%' }}>{item.plananme}</Text>
                                <Text style={{ width: '10%', textAlign: 'right' }}>{amount.toFixed(2)}</Text>
                                <Text style={{ width: '10%', textAlign: 'right' }}>{bookingData.noofdays} Day</Text>
                                <Text style={{ width: '15%', textAlign: 'right' }}>{totall.toFixed(2)}</Text>
                                <Text style={{ width: '10%', textAlign: 'right' }}>{diaamount.toFixed(2)} ({parseFloat(item.discount)}%)</Text>
                                <Text style={{ width: '15%', textAlign: 'right' }}>{roomrate.toFixed(2)}</Text>
                            </View>
                        );
                    })}
                </View>

                <View style={styles.tableContainer}>
                    <View style={styles.leftColumn}>
                        <Text style={styles.header1}>BANK DETAILS</Text>
                        <Text style={styles.label1}>Bank Name: Bank Of Maharashtra</Text>
                        <Text style={styles.label1}>Account No: 60442386856</Text>
                        <Text style={styles.label1}>IFSC Code: MAHB0000743</Text>
                        <Text style={styles.label1}>Account Name: Dasara Infraprojects</Text>
                        <Text style={styles.label1}>Branch: TULJAPUR</Text>
                    </View>

                    <View style={styles.rightColumn}>
                        <View style={styles.tableRow}>
                            <Text style={styles.label}>Subtotal</Text>
                            <Text style={styles.value}>{subtotal}</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={styles.label}>Total CGST (2.5%)</Text>
                            <Text style={styles.value}>{cgst}</Text>
                        </View>
                        {bookingData.customers.state === 'Maharashtra' ? (
                            <>
                                <View style={styles.tableRow}>
                                    <Text style={styles.label}>Total SGST (2.5%)</Text>
                                    <Text style={styles.value}>{cgst}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.label}>Total IGST</Text>
                                    <Text style={styles.value}>0.00</Text>
                                </View>
                            </>
                        ) : (
                            <>
                                <View style={styles.tableRow}>
                                    <Text style={styles.label}>Total SGST (0%)</Text>
                                    <Text style={styles.value}>0.00</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.label}>Total IGST (2.5%)</Text>
                                    <Text style={styles.value}>{cgst}</Text>
                                </View>
                            </>
                        )}
                        <View style={styles.tableRow}>
                            <Text style={styles.label}>Room Amount </Text>
                            <Text style={styles.value}>{roomtotal}</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={styles.label}>Extra Service</Text>
                            <Text style={styles.value}>{servicetotal}</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={styles.label}>Grand Total</Text>
                            <Text style={styles.value}>{parseFloat(bookingData.totalamount).toFixed(2)}</Text>
                        </View>
                    </View>
                </View>
                <Text style={styles.footer}>Total in Words: {amountInWords} Rupees Only</Text>
                <Text style={styles.footer1}>Thank you for choosing Dasara Executive!</Text>
            </Page>
        </Document>
    );




    return (
        <div>

            {isLoading && (
                <div style={overlayStyle}>
                    <ClipLoader color="#36d7b7" size={60} />
                </div>
            )}
            <Menu />
            {
                bookingData.customerId &&
                <div className="content-wrapper">
                    <section className="content mt-2">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="card card-primary card-outline">
                                        <div className="card-body box-profile">
                                            <h3 className="profile-username text-center" style={{ textTransform: "capitalize" }}>{bookingData.customers.custname} </h3>
                                            <p className="text-muted text-center">{bookingData.customers.mobile}</p>
                                            <center>
                                                <a style={{ marginTop: -20 }} className='btn btn-info' href='#0' onClick={verifyBookingData(documentId)} ><i className='fa fa-check'></i> Recheck Data</a>
                                            </center>
                                            <ul className="list-group list-group-unbordered mb-3">
                                                <li className="list-group-item">
                                                    <b>Email</b> <span className="float-right">{bookingData.customers.email}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Address</b> <span className="float-right">{bookingData.customers.city} {bookingData.customers.address} {bookingData.customers.state}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Gender</b> <span className="float-right">{bookingData.customers.gender}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>GST Name</b> <span className="float-right">{bookingData.customers.gstname}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>GST No</b> <span className="float-right">{bookingData.customers.gstno}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Document Type</b> <span className="float-right">{bookingData.customers.documenttype}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>ID No</b> <span className="float-right">{bookingData.customers.idno}</span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Visit Purpose</b> <span className="float-right">{bookingData.visitpurpose} </span>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Booking Source</b> <span className="float-right">{bookingData.bookingsource} </span>
                                                </li>

                                                <li className="list-group-item">
                                                    <b>Note</b> <span className="float-right">{bookingData.note} </span>
                                                </li>
                                            </ul>
                                            {
                                                bookingData.status === 'Booked' &&
                                                <a href="#0" data-toggle="modal" onClick={emptyRooms1} data-target="#checkoutModal" className="btn btn-primary btn-block"><b>Check Out </b></a>
                                            }
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <h6>Visitor Photo</h6>
                                            {
                                                bookingData.visitorPhotoUrl &&
                                                <img src={bookingData.visitorPhotoUrl} alt='img' width="100%" />
                                            }
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <h6>ID Proof Front</h6>
                                            {
                                                bookingData.idFrontUrl &&
                                                <img src={bookingData.idFrontUrl} alt='img' width="100%" />
                                            }
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <h6>ID Proof Back</h6>
                                            {
                                                bookingData.idBackUrl &&
                                                <img src={bookingData.idBackUrl} alt='img' width="100%" />
                                            }
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='card-body text-center'>
                                            <h6>Couple Photo</h6>
                                            {
                                                bookingData.couplePhotoUrl &&
                                                <img src={bookingData.couplePhotoUrl} alt='img' width="100%" />
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-9">
                                    <div className="card card-primary card-outline">
                                        <div className="card-body">
                                            <div className='card'>
                                                <div className='card-body'>
                                                    <div className='row'>
                                                        <div className='col-sm-6'>
                                                            <ul className="list-group ">
                                                                <li className="list-group-item">
                                                                    <b>Entry Timing</b> <span className="float-right">
                                                                        {entryTiming}
                                                                    </span>
                                                                </li>
                                                                <li className="list-group-item">
                                                                    <b>Checkin Date</b> <span className="float-right">
                                                                        {moment(bookingData.checkindate).format('DD/MM/YYYY')} {bookingData.checkintime}
                                                                    </span>
                                                                </li>

                                                                <li className="list-group-item">
                                                                    <b>Checkout Date</b> <span className="float-right">
                                                                        {moment(bookingData.checkoutdate).format('DD/MM/YYYY')} {bookingData.checkouttime}
                                                                    </span>
                                                                </li>
                                                                <li className="list-group-item">
                                                                    <b>No Of Days</b> <span className="float-right">{bookingData.noofdays} Day</span>
                                                                </li>
                                                                <li className="list-group-item">
                                                                    <b>Adults</b> <span className="float-right">{bookingData.adults} Adults</span>
                                                                </li>
                                                                <li className="list-group-item">
                                                                    <b>Childs</b> <span className="float-right">{bookingData.childs} Childs</span>
                                                                </li>
                                                                <li className="list-group-item">
                                                                    <b>No of Rooms</b> <span className="float-right">{bookingData.noofrooms} Rooms</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className='col-sm-6'>
                                                            <ul className="list-group ">
                                                                <li className="list-group-item">
                                                                    <b>Room Amount ({bookingData.rooamount.toFixed(2)} X {bookingData.noofdays} Days)</b> <span className="float-right">{roomtotal} </span>
                                                                </li>
                                                                <li className="list-group-item">
                                                                    <b>Extra Service</b> <span className="float-right">{bookingData.serviceamount.toFixed(2)} </span>
                                                                </li>
                                                                <li className="list-group-item">
                                                                    <b>Restaurant Amount</b> <span className="float-right">{bookingData.restoamount.toFixed(2)} </span>
                                                                </li>
                                                                <li className="list-group-item">
                                                                    <b>Round Off</b> <span className="float-right">{bookingData.roundoff} </span>
                                                                </li>
                                                                <li className="list-group-item">
                                                                    <b>Total Amount</b> <span className="float-right">{bookingData.totalamount.toFixed(2)} </span>
                                                                </li>
                                                                <li className="list-group-item">
                                                                    <b>Paid </b> <span className="float-right">{bookingData.advance.toFixed(2)}</span>
                                                                </li>
                                                                <li className="list-group-item">
                                                                    <b style={{ color: "red" }}>Remaining</b> <b className="float-right" style={{ color: "red" }}>{bookingData.remaining.toFixed(2)}</b>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="tab-content">
                                                <div className="active tab-pane" id="activity">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="row align-items-center">
                                                                <div className="col-sm-6">
                                                                    <h6 style={{ textTransform: "uppercase", margin: 0 }}>
                                                                        Room Details
                                                                    </h6>
                                                                </div>

                                                                <div className="col-sm-6 d-flex justify-content-end mb-2">
                                                                    {bookingData.status === "Booked" && (
                                                                        <>
                                                                            <button
                                                                                onClick={emptyRooms}
                                                                                data-toggle="modal"
                                                                                data-target="#roomModal"
                                                                                className="btn btn-sm btn-info"
                                                                            >
                                                                                Add New Rooms
                                                                            </button>

                                                                            &nbsp;&nbsp;

                                                                            <button
                                                                                onClick={emptyRooms}
                                                                                data-toggle="modal"
                                                                                data-target="#extendModal"
                                                                                className="btn btn-sm bg-purple"
                                                                            >
                                                                                Extend Rooms <i className="fa fa-external-link"></i>
                                                                            </button>

                                                                            &nbsp;&nbsp;

                                                                            <button
                                                                                onClick={emptyRooms}
                                                                                data-toggle="modal"
                                                                                data-target="#reduceModal"
                                                                                className="btn btn-sm bg-red"
                                                                            >
                                                                                Reduce Rooms <i className="fa fa-external-link"></i>
                                                                            </button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <table className='table'>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th>Room Type</th>
                                                                            <th>Room No</th>
                                                                            <th>Plan Name</th>
                                                                            <th>Amount</th>
                                                                            <th>Discount</th>
                                                                            <th>Room Rate</th>
                                                                            <th>Username</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        {
                                                                            bookingData.rooms.map((item, index) =>
                                                                                <tr key={index}>
                                                                                    <td>{item.roomtypename}</td>
                                                                                    <td>
                                                                                        {item.roomname}
                                                                                        {item.status === 'Exchanged' && " (Exchanged)"}
                                                                                    </td>
                                                                                    <td>{item.planid}</td>
                                                                                    <td>{item.amount}</td>
                                                                                    <td>{item.discount} %</td>
                                                                                    <td>{item.roomrate}</td>
                                                                                    <td>{item.username}</td>
                                                                                    <td>
                                                                                        <a onClick={() => handleOpenRoomEdit(index, item)} className="btn btn-sm btn-success mr-1" data-toggle="modal" data-target="#roomEditModal" href="#0" title="Edit Room"> <i className="fa fa-edit"></i></a>
                                                                                        <a onClick={() => emptyRooms2(item)} className="btn btn-sm bg-teal" data-toggle="modal" data-target="#exchangedModal" href="#0" title="Exchange Room"> <i className="fa fa-exchange"></i></a>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className='row'>
                                                                <div className='col-sm-6'>
                                                                    <h6 style={{ textTransform: "uppercase" }}>Extra Services</h6>
                                                                </div>
                                                                <div className='col-sm-6'>
                                                                    {
                                                                        bookingData.status === 'Booked' &&
                                                                        <button onClick={emptyRooms} data-toggle="modal" data-target="#serviceModal" style={{ marginTop: -8 }} className='btn btn-sm btn-success float-right'>Add Extra Service</button>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <table className='table'>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th>Service Name</th>
                                                                            <th>Room No</th>
                                                                            <th>Amount</th>
                                                                            <th>Quantity</th>
                                                                            <th>Discount</th>
                                                                            <th>Service Amount</th>
                                                                            <th>Username</th>
                                                                            <th>Time</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        {
                                                                            bookingData.services.map((item, index) =>
                                                                                <tr key={index}>
                                                                                    <td>{item.servicename}</td>
                                                                                    <td>{item.roomname}</td>
                                                                                    <td>{item.servamount}</td>
                                                                                    <td>{item.quantity}</td>
                                                                                    <td>{item.discount}</td>
                                                                                    <td>{item.servicerate}</td>
                                                                                    <td>{item.username}</td>
                                                                                    <td>
                                                                                        {item.createdAt?.toDate().toLocaleString()}
                                                                                    </td>
                                                                                    <td>
                                                                                        <a
                                                                                            onClick={() => cancleExtraService(item)}
                                                                                            className="btn btn-sm bg-red"
                                                                                            href="#0"
                                                                                        >
                                                                                            <i className="fa fa-close"></i>
                                                                                        </a>

                                                                                        &nbsp;

                                                                                        <a
                                                                                            href="#0"
                                                                                            className="btn btn-sm btn-info"
                                                                                            data-toggle="modal"
                                                                                            data-target="#updateServiceRoomModal"
                                                                                            onClick={() => {
                                                                                                setserviceId(item.serviceid);
                                                                                                setserviceRoomId(item.roomid || "");
                                                                                                setserviceRoomName(item.roomname || "");
                                                                                            }}
                                                                                        >
                                                                                            <i className="fa fa-edit"></i>
                                                                                        </a>

                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className='row'>
                                                                <div className='col-sm-8'>
                                                                    <h6 style={{ textTransform: "uppercase" }}>Payment History</h6>
                                                                </div>
                                                                <div className='col-sm-4'>
                                                                    {
                                                                        bookingData.remaining > 0 &&
                                                                        <>
                                                                            <button onClick={emptyRooms1} data-toggle="modal" data-target="#payModal" style={{ marginTop: -8 }} className='btn btn-sm btn-warning float-right'>Add Payment</button>&nbsp;
                                                                        </>
                                                                    }
                                                                    {
                                                                        bookingData.remaining < 0 &&
                                                                        <>
                                                                            <button onClick={emptyRooms1} data-toggle="modal" data-target="#payModal1" style={{ marginTop: -8 }} className='btn btn-sm btn-danger '>Return Payment</button>&nbsp;
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <table className='table'>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th>Paymode 1</th>
                                                                            <th>Amount 1</th>
                                                                            <th>Paytime 1</th>
                                                                            <th>Paymode 2</th>
                                                                            <th>Amount 2</th>
                                                                            <th>Paytime 2</th>
                                                                            <th>Datetime</th>
                                                                            <th>Note</th>
                                                                            <th>Username</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        {
                                                                            payhistory.map((item, index) =>
                                                                                <tr key={index}>
                                                                                    <td>{item.paymode1}</td>
                                                                                    <td>{item.data.amount1}</td>
                                                                                    <td>{item.data.paytime1}</td>
                                                                                    <td>{item.paymode2}</td>
                                                                                    <td>{item.data.amount2}</td>
                                                                                    <td>{item.data.paytime2}</td>
                                                                                    <td>{item.createdat}</td>
                                                                                    <td>{item.data.note}</td>
                                                                                    <td>{item.data.username}</td>
                                                                                    <td>
                                                                                        <button
                                                                                            onClick={() => handleOpenPayHistoryEdit(item)}
                                                                                            data-toggle="modal"
                                                                                            data-target="#payHistoryEditModal"
                                                                                            className="btn btn-sm btn-success mr-1"
                                                                                            title="Edit Payment"
                                                                                        >
                                                                                            <i className="fa fa-edit"></i>
                                                                                        </button>
                                                                                        <button
                                                                                            onClick={() => deletPyament(item.id)}
                                                                                            className="btn btn-sm bg-red"
                                                                                            title="Delete Payment"
                                                                                        >
                                                                                            <i className="fa fa-close"></i>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className='row'>
                                                                <div className='col-sm-6'>
                                                                    <h6 style={{ textTransform: "uppercase" }}>Check-In Details Datewise</h6>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <table className='table'>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th>Checkin Date</th>
                                                                            <th>Checkout Date</th>
                                                                            <th>Room Type</th>
                                                                            <th>Room No</th>
                                                                            <th>Plan Name</th>
                                                                            <th>Username</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                        {
                                                                            checkindetails.map((item, index) =>
                                                                                <tr key={index}>
                                                                                    <td> {moment(item.data.checkindate).format('DD/MM/YYYY')}</td>
                                                                                    <td> {moment(item.data.checkoutdate).format('DD/MM/YYYY')}</td>
                                                                                    <td>{item.data.roomtype}</td>
                                                                                    <td>{item.data.roomname}</td>
                                                                                    <td>{item.data.planid}</td>
                                                                                    <td>{item.data.username}</td>
                                                                                    <td>{item.id}</td>
                                                                                    <td>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* --- Room Edit Modal --- */}
                    <div className="modal fade" id="roomEditModal" tabIndex={-1} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-md" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit Room Amount & Rates</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-sm-12 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Amount"
                                                type="number"
                                                value={editRoomAmount}
                                                onChange={(e) => handleEditRoomAmountChange(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-sm-12 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Discount (%)"
                                                type="number"
                                                value={editRoomDiscount}
                                                onChange={(e) => handleEditRoomDiscountChange(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-sm-12 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Room Rate (Discounted)"
                                                type="number"
                                                value={editRoomRate}
                                                InputProps={{ readOnly: true }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        data-dismiss="modal"
                                        onClick={updateRoomDetails}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? "Saving..." : "Update Room"}
                                    </button>
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Other existing modals... */}
                </div>
            }
        </div>
    )
}

const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
};

const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontFamily: 'Helvetica',
    },
    section: {
        marginBottom: 10,
        padding: 10,
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    section1: {
        padding: 10,
    },
    section2: {
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    header: {
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    header1: {
        textAlign: 'center',
        fontSize: 15,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    subHeader: {
        textAlign: 'center',
        fontSize: 10,
        marginBottom: 5,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 5,
    },
    label: {
        fontSize: 10,
        fontWeight: 'bold',
    },
    label1: {
        fontSize: 10,
        fontWeight: 'bold',
        marginTop: 10,
        textAlign: "center"
    },
    value1: {
        fontSize: 10,
    },
    value: {
        fontSize: 10,
        textTransform: "capitalize"
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#e4e4e4',
        padding: 5,
        fontSize: 10,
        fontWeight: 'bold',
    },
    tableRow: {
        flexDirection: 'row',
        padding: 5,
        borderBottomWidth: 1,
        borderBottomColor: '#ddd',
        justifyContent: 'space-between',
        fontSize: 10,
    },
    footer: {
        fontSize: 13,
        marginTop: 20,
        textTransform: "capitalize"
    },
    footer1: {
        textAlign: 'center',
        fontSize: 10,
        marginTop: 50,
    },
    columnContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    columnContainer1: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        justifyContent: 'space-between',
        borderBottomColor: '#000',
    },
    column: {
        width: '48%',
    },
    column1: {
        width: '78%',
    },
    tableContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    leftColumn: {
        width: '48%',
        padding: 10,
    },
    rightColumn: {
        width: '48%',
        padding: 10,
    },

});

export default Viewdetails